import { useDealICMObject } from "@/src/hooks/data/useGameTable";
import usePlayerDetails from "@/src/hooks/data/usePlayerDetails";
import { RUPEE_SYMBOL } from "../../../../Poker/data/Constants";
import { useDispatch } from "react-redux";
import styles from "./A23DealConcluded.module.css";
import { checkToDisplayValueInCr, checkToDisplayValueInL, parseDecimalValuesOfNumber } from "../../../../Common/utils/GameUtils";
import useTourneyDealMaking from "@/src/hooks/utils/useTourneyDealMaking";

const A23DealConcluded = (props) => {
    const{ tempTableId } = props;
    const dispatch = useDispatch();

    const dealICMObject = useDealICMObject(tempTableId);
    const { winnersDetails } = dealICMObject || {};
    const { userName  } = usePlayerDetails();

    const { handleGoToLobby } = useTourneyDealMaking(tempTableId);

    const CreatePlayersTable = () => {
        return(
            <div className={styles.dealTableWrapper}>
                <div className={styles.dealTableHeaderWrapper}>
                    <span className={styles.tableHeadertext} style={{textAlign :'center'}}>Rank</span>          
                    <span className={styles.tableHeadertext} style={{textAlign :'left'}}>Username</span>
                    <span className={styles.tableHeadertext} style={{textAlign :'end'}}>Winnings</span>
                </div>
                <div className={styles.dealTableBodyWrapper}>
                    {Object.entries(winnersDetails).map(([playerName, dealDetails], index) => (
                        <div className={styles.playerDetailsWrapper} key={`${playerName}-${index}`}>
                            <span className={`${styles.tableItemText} ${playerName === userName ? styles.loggedInPlayerText : ""}`} style={{textAlign :"center"}}>{dealDetails?.rank}</span>
                            <span className={`${styles.playerNameText} ${playerName === userName ? styles.loggedInPlayerText : ""}`} isLoggedInPlayer={playerName === userName}>{playerName}</span>
                            <span className={`${styles.tableItemText} ${playerName === userName ? styles.loggedInPlayerText : ""}`} style={{textAlign :'end'}}>
                                {dealDetails?.win > 0 ?
                                    `${RUPEE_SYMBOL}
                                        ${parseDecimalValuesOfNumber(
                                        dealDetails?.win,
                                        2,
                                        false,
                                        checkToDisplayValueInL(dealDetails?.win),
                                        checkToDisplayValueInCr(dealDetails?.win)
                                    )}` : ""}
                                {(dealDetails?.win > 0  && dealDetails?.bonus > 0) ? "+" : ""}
                                {dealDetails?.bonus > 0 ?
                                    `${RUPEE_SYMBOL}${dealDetails.bonus}(Bonus)` : ""
                                }
                            </span>
                        </div>)
                    )}
                </div>
            </div>
        )
    }
    return (
        <div className={styles.dealDoneWrapper}
            onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
            }}
        >
            <div className={styles.dealConcludedHeader}>
                Deal Done
            </div>
            <div className={styles.dealConcludedBodyWrapper}>
                <span className={styles.descriptionText}>Congratulations to all players</span>
                <CreatePlayersTable />
                <button className={styles.goToLobbyButton}
                    onClick={handleGoToLobby}
                >
                    Go to Lobby
                </button>

            </div>
        </div>
    )
}

export default A23DealConcluded;